import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { Field, Form } from "react-final-form";
import { i18n } from "../../../utils/i18n";
import { Button, Chip, TextField, Typography, makeStyles } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import { Trans } from "@lingui/macro";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import ImportWords from "./ImportWords";

const MaxCustomWords = 500;

const useStyles = makeStyles((theme) => ({
    chipWrapper: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(0.5),
        },
        width: '100%',
        boxShadow: '0 0 3px #aaa',
        borderRadius: '10px',
        marginTop: '10px',
        padding: '4px',
        minHeight: '48px',
        alignItems: 'center'
    },
    emptyLabel: {
        margin: 0,
        color: '#aaa'
    }
}));

const CreateWordsListForm = (props) => {
    const [name, setName] = useState('');
    const [currentWord, setCurrentWord] = useState('');
    const [words, setWords] = useState([]);

    useEffect(() => {
        setName(!props.updateItem ? '' : props.updateItem.name);
        setWords(!props.updateItem ? [] : props.updateItem.list);
        setCurrentWord('');
    }, [props.updateItem]);

    const onSubmit = async () => {
        if (!name || !words.length) return;

        if (props.onSubmit && !(await props.onSubmit({ name: name, words: words })))
            return;

        setName('');
        setCurrentWord('');
        setWords([]);
    };

    const defineCurrentWord = value => {
        setCurrentWord(
            value.replace(';', '')
        );
    };

    const appendWordItem = () => {
        const currentWords = currentWord.split(',');
        for(const word of currentWords) {
            const appendedWord = word.trim();
            if (!appendedWord.length || words.includes(appendedWord) || words.length >= MaxCustomWords) continue;
            setWords(state => [...state, appendedWord]);
        }
        setCurrentWord('');
    };

    const deleteWordItem = word => {
        setWords(state => [...(state.filter(w => w != word))]);
    };

    const onCancel = () => {
        if (props.onCancel) props.onCancel();
    };

    const classes = useStyles();

    return (
        <>
            <form>
                <Typography variant="h5" align="center">
                    {
                            props.updateItem 
                        ?
                            (<Trans>Mettre à jour un dictionnaire</Trans>)
                        :
                            (<Trans>Créer un dictionnaire</Trans>)
                    }
                </Typography>
                <Box p={1}>
                    <TextField label={props.updateItem ? "Edition" : "Nom du dictionnaire"} variant="outlined" fullWidth onChange={(e) => (!props.updateItem && setName(e.target.value))} value={name} />
                </Box>
                <Box p={1}>
                    <TextField
                        label={`Insérer les mots ici (${words.length}/${MaxCustomWords})`}
                        fullWidth
                        onChange={(e) => defineCurrentWord(e.target.value)}
                        onKeyUp={(e) => {
                            if (e.key != 'Enter') return;
                            e.preventDefault();
                            appendWordItem();
                        }}
                        value={currentWord}
                    />
                    <div className={classes.chipWrapper}>
                        {words.length ? words.map(word => (
                            <Chip key={`word-item-${word}`} label={word} variant="outlined" onDelete={() => deleteWordItem(word)} />
                        )) : (<label className={classes.emptyLabel}><Trans>Aucun mots</Trans></label>)}
                    </div>
                </Box>
                <Button  variant="contained" color="primary" fullWidth onClick={onSubmit} className="shadow-2 mb-4" style={{ width: props.updateItem ? '50%' : undefined }}>
                    {
                        props.updateItem 
                            ?
                        (<Trans>Mettre à jour un dictionnaire</Trans>)
                            :
                        (<Trans>Créer un dictionnaire</Trans>)
                    }
                </Button>
                {props.updateItem && (
                    <Button variant="contained" color="primary"  onClick={onCancel} className="shadow-2 mb-4" style={{ width: props.updateItem ? '50%' : undefined }}>
                        <Trans>Annuler</Trans>
                    </Button>
                )}
            </form>
              {props.updateItem && (
                <Box p={1}>
                    <Divider />
                      <Box p={1}>
                        <Typography variant="body2" align="center" color="textSecondary">   
                            <Trans>Vous pouvez importer un fichier texte contenant les mots de votre dictionnaire. Chaque mot doit être sur une ligne séparée. Les mots en double seront ignorés.</Trans>
                             <Trans>Les mots remplaceront les mots existants.</Trans>
                        </Typography>
                    </Box>  
                    <Box mt={2} display="flex" justifyContent="center">
                        <ImportWords
                            selectedList={props.updateItem}
                            updateWordsList={props.onSubmit}
                        />
                    </Box>
                </Box>
            )}
          
        </>
    );
}

export default CreateWordsListForm;